<template>
  <!-- 搜索引擎 -->
  <div id="search">
    <van-popup v-model="showStart" position="bottom" :style="{ height: '50%' }">
      <div>
        <!-- <van-divider
          :style="{
            color: '#1989fa',
            borderColor: '#1989fa',
            fontSize: '16px',
          }"
        >
          请选择开始时间
        </van-divider> -->
        <div class="page-title">请选择开始时间</div>
        <van-datetime-picker
          v-model="currentDateStart"
          type="date"
          :min-date="minDateStart"
          :max-date="maxDateStart"
          @confirm="confirmStateTime"
          @cancel="showStart = false"
        />
      </div>
    </van-popup>
    <van-popup v-model="showEnd" position="bottom" :style="{ height: '50%' }">
      <div>
        <van-divider
          :style="{
            color: '#1989fa',
            borderColor: '#1989fa',
            fontSize: '16px',
          }"
        >
          请选择结束时间
        </van-divider>
        <van-datetime-picker
          v-model="currentDateEnd"
          type="date"
          :min-date="minDateEnd"
          :max-date="maxDateEnd"
          @confirm="confirmEndTime"
          @cancel="backToShowStart"
        />
      </div>
    </van-popup>
    <van-search
      v-model="keyword"
      show-action
      clearable
      shape="round"
      :placeholder="placehold"
      @input="changeKeyword"
      @search="onSearch"
      @clear="clearSearch"
    >
      <template #action>
        <div class="searchBtnStyle" @click="onSearch">查询</div>
      </template>
    </van-search>
    <van-popup v-model="potencePopShow" position="bottom">
      <div style="text-align:center">
        <van-cell
          center
          :title="item.text"
          v-for="item in potenceOptions"
          :key="item.value"
          :style="potenceValue === item.value ? 'color:#0084FF' : ''"
          @click="changePotence(item.value)"
        ></van-cell>
        <van-cell 
          class="cell-cancel"
          title="取消" 
          @click="potencePopShow = false" />
      </div>
    </van-popup>
    <!-- 法院列表 -->
    <van-popup v-model="courtPopShow" position="bottom">
      <div style="text-align:center">
        <van-cell
         center
          :title="item.text"
          v-for="item in courtOptions"
          :key="item.value"
          :style="courtValue === item.value ? 'color:#7E6850' : ''"
          @click="changeCourt(item.value)"
        ></van-cell>
        <van-cell 
          class="cell-cancel"
          title="取消" 
          @click="courtPopShow = false" />
      </div>
    </van-popup>
    <!-- 税务种类列表 -->
    <van-popup v-model="taxPopShow" position="bottom">
      <div style="text-align:center">
        <van-cell
          v-for="it in taxOptions"
          :title="it.text"
          :key="it.code"
          :style="taxValue === it.code ? 'color:#0084FF' : ''"
          @click="changeTax(it.code)"
        ></van-cell>
      </div>
    </van-popup>
    <!-- 法规or解答 -->
    <div v-if="$route.path=='/newSearchEngine'"
      class="which-type">
      <van-button class="law-btn" :class="currentType == 1 ? 'choosed-btn': ''" square size="small"  @click="chooseType(1)">政策法规</van-button>
      <van-button class="answer-btn" :class="currentType == 2 ? 'choosed-btn': ''" square  size="small" @click="chooseType(2)">官方解答</van-button>
    </div>

    <div class="select-box" 
        :class="$route.path!='/answer' 
        && $route.path!='/taxForm'
         && currentType == 1 ? '': 'block-box'">
      <template 
        v-if="$route.path!='/answer' && currentType == 1 &&
        $route.path!='/judgeCase' && $route.path!='/taxCase' &&
        $route.path!='/taxForm'">
        <div class="potence-box">
          <div class="potence-title" @click="potenceBtn">
            {{ potenceValue !== "" ? potenceText : "文件效力" }}
            <span class="potence-sanjiao"></span>
          </div>
        </div>
      </template>
      <template v-if="$route.path =='/judgeCase'">
        <div class="potence-box" @click="courtBtn">
          <div class="potence-title" >
            {{ courtValue !== "" ? courtText : "全部法院" }}
            <span class="potence-sanjiao"></span>
          </div>
        </div>
      </template>
      <template v-if="$route.path =='/taxCase'">
        <div class="potence-box" @click="taxBtn">
          <div class="potence-title" >
            {{ taxValue !== "" ? taxText : "全部分类" }}
            <span class="potence-sanjiao"></span>
          </div>
        </div>
      </template>

      <div v-if="$route.path!='/expertAnswer'" class="timeBox" :class="startAndEndTimeOne!== ''? 'chosed-timeBox' :''">
        <div class="time" @click="timeBtn">
          <div>
            {{
              startAndEndTimeOne !== "" && startAndEndTimeTwo !== ""
                ? `${startAndEndTimeOne}-${startAndEndTimeTwo}`
                : "时间范围"
            }}
          </div>
          <span class="time-sanjiao"></span>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  props: {
    folderid: {
      type: String,
      default: "",
    },
    placehold: {
      type: String,
      default: "请输入查询内容",
    },
    // newSearchText: {
    //   type: String,
    //   default: "",
    // },
  },
  data() {
    return {
      keyword: "", // 搜索框的内容
      minDateStart: new Date(1949, 0, 1),
      maxDateStart: new Date(),
      minDateEnd: new Date(1949, 0, 1),
      maxDateEnd: new Date(),
      currentDateStart: new Date(), // 开始时间
      currentDateEnd: new Date(), // 结束时间
      dateStart: "", // 选择后的开始时间
      dateEnd: "", // 选择后的结束时间
      showStart: false, // 选择开始时间弹框
      showEnd: false, // 选择结束时间按弹框
      startAndEndTimeOne: "", //开始和结束时间区间显示
      startAndEndTimeTwo: "", //开始和结束时间区间显示
      potencePopShow: false, // 打开文件效力弹框
      courtPopShow: false, // 打开法院弹窗
      potenceValue: "",
      potenceOptions: [
        // { text: "请选择", value: "" },
        { text: "全部效力", value: "1" },
        { text: "全文有效", value: "20" },
        { text: "尚未生效", value: "0" },
        { text: "部分废止(失效)", value: "30" },
        { text: "全文废止(失效)", value: "40" },
      ],
      courtOptions: [
        { text: "全部法院", value: 0 },
        { text: "最高法院", value: 1 },
        { text: "高级法院", value: 2 },
        { text: "中级法院", value: 3 },
        { text: "基层法院", value: 4 },
      ],
      potenceText: "文件效力",
      courtValue: "",
      courtText: "全部法院",
      currentType: 1,
      taxOptions: [],
      taxValue: "",
      taxText: "全部分类",
      taxPopShow: false
    };
  },
  created() {
    // if (this.newSearchText !== "") {
    //   this.keyword = this.newSearchText;
    // }
    this.getTaxClassify()
  },
  methods: {
    getTaxClassify() {
      this.$http.reqGetTaxClassify().then((res) => {
      res.datas.unshift({ pptr:"", code:"", text:"全部分类", expand: false, shortText:"", showSequence: 0 })
      // console.log('-0-', res.datas)
      this.taxOptions = res.datas
      });
    },
    // 选择类型
    chooseType (e) {
      this.currentType = e
      this.$emit('chooseType', e)
    },
    // 清除搜索框
    clearSearch() {
      this.onSearch();
    },
    // 点击搜索按钮
    onSearch() {
      // if (this.keyword) {
      this.$emit("changeFirstTime", false);
      this.$emit("searchKeyWord", this.keyword);
      // }
    },
    timeBtn() {
      if (this.startAndEndTimeOne !== "" && this.startAndEndTimeTwo !== "") {
        this.clearTime();
      }
      console.log("this.folderid", this.folderid);
      if (!this.folderid && this.$route.fullPath === "/smartcloud") {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请先选择文件夹",
          duration: 5000,
        });
      } else {
        this.showStart = true;
      }
    },
    // 选择结束时间的取消按钮
    backToShowStart() {
      this.showStart = true;
      this.showEnd = false;
    },
    // 开始时间弹框
    confirmStateTime(val) {
      this.showStart = false;
      this.showEnd = true;
      this.dateStart = this.moment(val).format("YYYY-MM-DD");
    },
    // 结束时间弹框
    confirmEndTime(val) {
      this.dateEnd = this.moment(val).format("YYYY-MM-DD");
      if (this.dateStart > this.dateEnd) {
        this.$toast.fail({
          message: "开始时间不能大于结束时间",
          duration: 5000,
        });
        this.showEnd = true;
      } else {
        this.showEnd = false;
        this.startAndEndTimeOne = this.dateStart;
        this.startAndEndTimeTwo = this.dateEnd;
        let timeObj = {
          stime: this.dateStart,
          etime: this.dateEnd,
        };
        this.$emit("changeFirstTime", false);
        this.$emit("selectTime", timeObj);
      }
    },
    // 清除时间范围
    clearTime() {
      this.startAndEndTimeOne = "";
      this.startAndEndTimeTwo = "";
      this.$emit("clearTime");
    },
    // 清除搜索框的内容和清除时间
    clearMsg() {
      this.keyword = "";
      this.startAndEndTimeOne = "";
      this.startAndEndTimeTwo = "";
    },
    // 文件效力按键
    potenceBtn() {
      this.potencePopShow = true;
      // this.$nextTick(() => {
      //   console.log(this.$refs.slowdownitem);
      //   this.$refs.slowdownitem.toggle();
      // });
    },
    // 打开选择法院弹窗
    courtBtn() {
      this.courtPopShow = true;
    },
    // 打开税务种类弹窗
    taxBtn() {
      this.taxPopShow = true
    },
    // 改变效力
    changePotence(val) {
      // this.potenceOptions.find((item) => {
      //   if (item.value === val) {
      //     this.potenceText = item.text;
      //     return;
      //   }
      // });
      this.$emit("changeFirstTime", false);
      this.$emit("changePotence", val);

      this.potenceValue = val;
      this.potencePopShow = false;
    },
    // 改变法庭
    changeCourt(val) {
      this.courtValue = val;
      this.courtPopShow = false;
      this.$emit("changeCourt", val);
    },
    changeTax(val) {
      this.taxValue = val;
      this.taxPopShow = false
      this.$emit("changeTax", val)
    },
    //
    changeKeyword(val) {
      this.$store.commit("changeSomeThing/setNewSearchText", val);
    },
    clearPotence() {
      this.potenceValue = "1";
    },
  },
  watch: {
    potenceValue() {
      let temp = this.potenceOptions.find((item) => {
        if (item.value === this.potenceValue) {
          return item;
        }
      });
      console.log("改变potenceval", temp);
      this.potenceText = temp.text;
    },
    courtValue() {
      let temp = this.courtOptions.find((item) => {
        if (item.value === this.courtValue) {
          return item;
        }
      });
      this.courtText = temp.text;
    },
    taxValue() {
      let temp = this.taxOptions.find((item) => {
        if(item.code === this.taxValue) {
          return item;
        }
      })
      this.taxText = temp.text
    }
  },
};
</script>

<style lang="less" scoped>
 
#search {
  /deep/.van-cell::after {
    border-bottom: 1px solid#f0f0f0;
  }
//  /deep/.van-cell:nth-last-child(2)::after{
//     border-bottom: none;
//   }
  .page-title {
    color: #000;
    border-color: #1989fa;
    font-size: 16px;
    text-align: center;
    margin: 15px 0 0px 0;
    font-weight: bold;
  }
  /deep/.van-picker__confirm {
    color: #4D8FFE;
  }
  .which-type {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    margin: 10px 0;
    .law-btn, .answer-btn {
      border-radius: 5px;
    }
    .choosed-btn {
      color: #fff;
      background: #0084FF;
    }
  }
  .van-popup {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .cell-cancel {
    border-top: 10px solid #eaeaea;
  }
  
  .select-box {
    padding-top: 5px;
    padding-bottom: 5px;
    display: flex;
    justify-content: space-between;
    background-color: #f7f8fa;
    
  }
  .block-box {
    display: flex;
    justify-content: flex-end;
    background-color: #f7f8fa;
  }
  
  .timeBox {
    // width: 50%;
    height: 35px;
    display: flex;
    color: #000;
    padding: 0 5px 0 10px;
    margin: 0 20px 2px 0;
    border-radius: 30px;
    background-color:none;
    .time {
      position: relative;
      flex: 1;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 8px;
      .time-sanjiao {
        position: absolute;
        top: 15px;
        right: -10px;
        border: 6px solid transparent;
        border-top: 6px solid #000;
        border-radius: 4px;
      }
    }
    .icon {
      margin-right: 6px;
      margin-left: 2px;
    }
  }
  .chosed-timeBox {
    color: #F76E21;
    .time-sanjiao {
      border-top: 6px solid #F76E21 !important;
    }
  }
  .potence-box {
    position: relative;
    display: flex;
    align-items: center;
    margin-left: 10px;
    border-radius: 30px;
    //width: 90px;
    height: 35px;
    // width: 50%;
    .potence-title {
      position: relative;
      margin-left: 10px;
      margin-right: 20px;
      .potence-sanjiao {
        position: absolute;
        top: 8px;
        right: -16px;
        border: 6px solid transparent;
        border-top: 6px solid #333;
        border-radius: 4px;
      }
    }
  }
  .searchBtnStyle {
    width: 80px;
    height: 100%;
    height: 0.95rem;
    line-height: 0.95rem;
    text-align: center;
    border-radius: 0 0.95rem 0.95rem 0;
    font-size: 14px;
    color: #fff;
  }
}
</style>
